import "core-js/modules/es6.object.assign";
import React from 'react';
export default function InfoMessage(props) {
  return /*#__PURE__*/React.createElement("div", Object.assign({}, props, {
    style: {
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      right: 0
    }
  }));
}